// Copyright (c) 2026 Or2 LLC. All rights reserved.
// Insight Platform - proprietary software by Nnaico (https://nnaico.com).
// See the LICENSE file in this repository. All rights reserved.

import { useState, useEffect } from 'react';

export const ConversationStarters = ({
  starters = [],
  onSelectStarter
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!starters || starters.length === 0) {
    return null;
  }

  const handleClick = (starter) => {
    // Handle both string and object formats
    let prompt;
    if (typeof starter === 'string') {
      prompt = starter;
    } else if (starter && typeof starter === 'object') {
      prompt = starter.prompt || starter.label;
    }

    if (prompt) {
      onSelectStarter(prompt.trim());
    }
  };

  const getLabel = (starter) => {
    if (typeof starter === 'string') {
      return starter;
    }
    return starter?.label || starter?.prompt || '';
  };

  const getPrompt = (starter) => {
    if (typeof starter === 'string') {
      return starter;
    }
    return starter?.prompt || starter?.label || '';
  };

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      onSelectStarter(selectedValue.trim());
      e.target.value = ''; // Reset select after selection
    }
  };

  // Mobile: render as dropdown
  if (isMobile) {
    return (
      <div className="chat-starters-content chat-starters-mobile">
        <select
          className="conversation-starter-select"
          onChange={handleSelectChange}
          defaultValue=""
        >
          <option value="" disabled>Conversation starters...</option>
          {starters.map((starter, index) => (
            <option key={index} value={getPrompt(starter)}>
              {getLabel(starter)}
            </option>
          ))}
        </select>
      </div>
    );
  }

  // Desktop: render as buttons
  return (
    <div className="chat-starters-content">
      <span className="conversation-starters-label">Conversation starters:</span>
      {starters.map((starter, index) => (
        <button
          key={index}
          onClick={() => handleClick(starter)}
          className="conversation-starter-chip"
        >
          {getLabel(starter)}
        </button>
      ))}
    </div>
  );
};
